import { render, staticRenderFns } from "./TeachingDare.vue?vue&type=template&id=626b7ebc&"
import script from "./TeachingDare.vue?vue&type=script&lang=js&"
export * from "./TeachingDare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports